import { render, staticRenderFns } from "./new.notifications.page.vue?vue&type=template&id=793517ee&"
import script from "./new.notifications.page.vue?vue&type=script&lang=js&"
export * from "./new.notifications.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports